import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';
import ConsoleStore from '../../stores/ConsoleStore';
import { CUSTOMIZATION_TYPE } from '../../stores/CustomizeUI/CustomizeUIConstants';
import CustomizeUIStore from '../../stores/CustomizeUI/CustomizeUIStore';
import { BrandingOptionView, HelpButtonView } from '../BrowserBarOptions/BrowserBarFields';
import { ExitMessageOptionView } from '../ConsoleExitMessage/ExitMessageFields';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import { Card, Field } from '../Fuse';
import FuseButton from '../FuseControls/FuseButton';
import PreviewController from './PreviewController';
import { BlockPageEnabledView } from './BlockPageFields';


const customOrDefault = (isCustom) => (isCustom ? BlockPageEnabledView.CUSTOM : BlockPageEnabledView.DEFAULT);
class CustomizeUIReadOnlyModal extends Component {
    static propTypes = {
        store: PropTypes.any,
        customizeUI: CustomizeUIStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
    };


    renderOption = {
        [CUSTOMIZATION_TYPE.CONTENT_FILTERING]: (store) => customOrDefault(store.enabled.getValue()),
        [CUSTOMIZATION_TYPE.MALICIOUS_THREAT]: (store) => customOrDefault(store.enabled.getValue()),
        [CUSTOMIZATION_TYPE.BROWSER_BAR]: (store) => BrandingOptionView[store.brandingOption.getValue()],
        [CUSTOMIZATION_TYPE.EXIT_MESSAGE]: (store) => ExitMessageOptionView[store.option.getValue()],
        [CUSTOMIZATION_TYPE.REGISTRATION_NOTICE]: (store) => (store.enabled.getValue() ? 'Enabled' : 'Disabled'),
    };
    showPreview(store) {
        if (store.metadata.customizationType === CUSTOMIZATION_TYPE.REGISTRATION_NOTICE &&
            !store.enabled.getValue()) {
            return false;
        }
        return true;
    }

    render() {
        const { customizeUI } = this.props;
        if (!customizeUI.readOnlyModal.isOpen()) {
            return null;
        }

        const store = customizeUI.readOnlyModal.getValue();
        return <FuseConsoleModal
            isOpen
            onClose={customizeUI.readOnlyModal.close}
            title={store.metadata.name}
            headerActions={this.props.console.authority === ROLE_READ_ONLY.value ? null : <FuseButton
                type="primary"
                color="blue"
                icon="edit"
                onClick={() => {
                    customizeUI.readOnlyModal.close();
                    store.editModal.open();
                }}
                qa="customize-ui-read-only-modal-edit-button"
            >Edit</FuseButton>}
        >
            <Card title="Summary">
                <Field label="Name">{store.metadata.name}</Field>
                <Field label="Description">{store.metadata.description}</Field>
                <Field label="Type">{store.metadata.type}</Field>
                <Field label="Option">{this.renderOption[store.metadata.customizationType]?.(store)}</Field>
                {store.metadata.customizationType === CUSTOMIZATION_TYPE.BROWSER_BAR
                    ? <Field label="Help Link">{HelpButtonView[store.helpButton.getValue()]}</Field>
                    : null}
            </Card>
            {this.showPreview(store) ? <Card title="Preview">
                <PreviewController store={store} />
            </Card> : null}
        </FuseConsoleModal>;
    }
}


export default inject('customizeUI', 'console')(observer(CustomizeUIReadOnlyModal));
